<template>
  <section class="write-a-review-section">
    <div class="container">
      <b-row class="p-3 text-center">
        <b-col :cols="isTeacher ? '6' : '12'">
          <!--      <h5 class="heading">Rating</h5>-->
          <div class="current-rating">
            <h1>{{ rating.toFixed(1) }}</h1>
            <div class="ratings">
              <star-rating v-model="rating" v-bind="starattribs"></star-rating>
            </div>
          </div>
        </b-col>
        <b-col :cols="isTeacher ? '6' : '12'">
          <div class="add-review-rating text-center">
            <b-button variant="primary" pill size="md" @click="addReview"
              >Add a Review</b-button
            >
          </div>
        </b-col>
      </b-row>
      <hr v-if="isTeacher" />
    </div>
    <review-modal
      :course-id="courseId"
      :course-name="courseName"
      :isTeacher="isTeacher"
      :review="review"
    />
  </section>
</template>

<script>
import ReviewModal from "../modals/ReviewModal";
import { mapGetters } from "vuex";
import { store } from "../../store/store";

export default {
  name: "WriteReview",
  components: {
    ReviewModal
  },
  computed: {
    ...mapGetters("user", ["isAuthenticated"]),
    ...mapGetters("events", ["getAddReview"])
  },
  data() {
    return {
      starattribs: {
        readOnly: true,
        starSize: 13,
        showRating: false,
        activeColor: "#faa30c"
      }
    };
  },
  methods: {
    addReview() {
      if (this.isAuthenticated && (this.isSubscribed || this.price === 0)) {
        this.$bvModal.show("reviewmodal");
      } else if (
        this.isAuthenticated &&
        (!this.isSubscribed || this.price !== 0)
      ) {
        this.$bvToast.toast(`You have subscribe the course First`, {
          title: "Add Review",
          autoHideDelay: 500,
          appendToast: true
        });
      } else {
        store.dispatch("events/setAddReview", true);
        this.$bvModal.show("modal-1");
      }
    }
  },
  props: {
    isTeacher: Boolean,
    isSubscribed: {
      type: Boolean,
      default: true
    },
    courseId: String,
    courseName: String,
    rating: {
      type: Number,
      default: 0
    },
    review: {},
    price: Number
  },
  watch: {
    getAddReview() {
      if (!this.getAddReview) {
        this.addReview();
      }
    }
  }
};
</script>

<style scoped></style>
